import { render } from "./DebuggerModule.vue?vue&type=template&id=23b9b9bc&scoped=true"
import script from "./DebuggerModule.vue?vue&type=script&lang=js"
export * from "./DebuggerModule.vue?vue&type=script&lang=js"

import "./DebuggerModule.vue?vue&type=style&index=0&id=23b9b9bc&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b9b9bc"]])

export default __exports__